import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FileManagementService} from '@core/services/file-management.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {DownloadDialogComponent} from '@shared/components/download-dialog/download-dialog.component';
import {DoNothingAction} from '@shared/store/actions/particle.actions';

@Injectable({
  providedIn: 'root',
})
export class DownloadCbCFormReportCommandHandler implements IPlatformCommandHandler {

  constructor(private commandService: CommandService,
              private snackbarService: SnackBarService,
              private fileManagementService: FileManagementService,
              private fuseSplashScreenService: FuseSplashScreenService) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    this.fuseSplashScreenService.show();

    const fileId = command.fieldValues['FileId'];
    const fileName = command.fieldValues['FileName'];

    if (fileId && fileName) {
      this.fileManagementService.downloadClientFileWithIdOneTimeSignedUrl(fileId)
        .subscribe(payload => {
            this.fileManagementService.downloadOneTimeSignedUrl(payload.url, fileName);
            this.fuseSplashScreenService.hide();
          });
    } else {
      this.fuseSplashScreenService.hide();
    }

    return true;
  }

}
